import * as React from 'react';
import { Link } from 'react-router';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DotDelimeter } from '../../Dsi/General/DotDelimeter';
import { getArticleDefaultInfo } from '../../../utilities/selectors';
import { Picture } from '../Picture/Picture';
import { getImagePath } from '../../../utilities/product';
import { prop } from '../../../utilities';

export interface Props {
  article: any;
  categoryName: string | null;
}

function ArticleListItem({ article, categoryName }: Props) {
  const { url, title, pictureSrc, date, author } = getArticleDefaultInfo(
    article,
  );
  const annotation =
    prop(article, 'annotation') || prop(article, 'json_content.annotation');
  // categoryName = 'Radca';
  return (
    <Wrapper to={url}>
      {
        <Picture
          srcNoWebP={
            pictureSrc
              ? getImagePath(
                  pictureSrc,
                  { width: 524, height: 324 },
                  false,
                  false,
                  true,
                )
              : '/images/icons/placeholder.svg'
          }
          srcWebP={
            pictureSrc
              ? getImagePath(
                  pictureSrc,
                  { width: 524, height: 324 },
                  false,
                  true,
                  true,
                )
              : '/images/icons/placeholder.svg'
          }
          alt={`Obrázok ku článku ${title}`}
          customStyles={imageShared}
        />
      }

      {/*
      <Image src={picture} alt={`Obrázok ku článku ${title}`} />
      */}

      <BottomWrapper>
        <Title>{title}</Title>
        <Annotation dangerouslySetInnerHTML={{ __html: annotation }} />
        <DateCategoryWrapper>
          {categoryName && <CategoryName>{categoryName}</CategoryName>}
          {categoryName && <DotDelimeter />}
          <Date>{date}</Date>
          {author && <DotDelimeter />}
          {author && <CategoryName>{author}</CategoryName>}
        </DateCategoryWrapper>
      </BottomWrapper>
    </Wrapper>
  );
}

const imageShared = css`
  max-width: ${rem(224)};
  min-height: ${rem(224)};
  flex: 1 1 ${rem(224)};
  height: initial;
  border-radius: ${rem(4)};
  object-fit: cover;

  ${({ theme }) => theme.mediab.m580`
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
    // height: ${rem(224)};
  `}
`;

const Wrapper = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-flow: row;
  width: 100%;
  flex: 1 1 100%;
  margin-bottom: ${rem(32)};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mediab.m580`
    flex-wrap: wrap;
    justify-content: center;
  `}
`;

const Image = styled.img`
  width: 100%;
  max-width: ${rem(224)};
  min-height: ${rem(224)};
  flex: 1 1 ${rem(224)};
  height: initial;
  border-radius: ${rem(4)};
  object-fit: cover;

  ${({ theme }) => theme.mediab.m580`
    max-width: 100%;
    flex-basis: 100%;
    height: ${rem(224)};
  `}
`;

const BottomWrapper = styled(FlexCol)`
  justify-content: flex-start;
  width: 100%;
  padding: 0 ${rem(24)} ${rem(24)};
  margin: 0 auto;

  ${({ theme }) => theme.mediab.m580`
    padding-top: ${rem(24)};
  `}
`;

const Title = styled.h2`
  font-weight: 500;
  font-size: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(31)};
  margin-top: 0;
  margin-bottom: ${rem(16)};
  font-family: ${({ theme }) => theme.font.primary};
  text-transform: uppercase;

  &:hover {
    text-decoration: underline;
  }
`;

const Annotation = styled.div`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
`;

const DateCategoryWrapper = styled(FlexRowCenterVertical)`
  padding-top: ${rem(24)};
`;

const textMutedLikeCss = css`
  font-size: ${rem(16)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  line-height: ${rem(20)};
  font-weight: 400;
`;

const Date = styled(TextP)`
  ${textMutedLikeCss};
`;

const CategoryName = styled(Date)``;

export { ArticleListItem };
